import * as React from 'react';
import { Link } from 'react-router-dom';
import logo = require('../../images/logo.png');
import * as styles from './header.module.scss';
import UserMenu from '../user-menu/user-menu';
import Paths from '../../models/enums/paths';
import { AppContext } from '../../shared/app-context';
import HeaderLink from './header-link';

const Header = () => {
  const { state } = React.useContext(AppContext);
  const managementUrl =
    window.env.MANAGEMENT_URL !== null && window.env.MANAGEMENT_URL !== undefined
      ? window.env.MANAGEMENT_URL
      : Paths.Management;
  const userInterface =
    window.env.USER_INTERFACE !== null && window.env.USER_INTERFACE !== undefined
      ? window.env.USER_INTERFACE
      : 'default';

  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <Link to="/">
          <img src={logo} />
        </Link>
      </div>
      <div className={styles.menu}>
        {state.isAdmin && userInterface !== 'management' && (
          <HeaderLink title="Management" path={managementUrl} isExternal={managementUrl.indexOf('http') === 0} />
        )}
        {state.enableServiceDesk && userInterface !== 'management' && (
          <HeaderLink title="Support" path={Paths.Support} isExternal={false} />
        )}
        {userInterface !== 'management' && <HeaderLink title="Help" path={Paths.Help} isExternal={false} />}
        <UserMenu />
      </div>
    </div>
  );
};
export default Header;
